import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";

export default function SoftwareSkill() {
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {skillsSection.softwareSkills.map((skills, i) => {
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
            <i
  className={skills.fontAwesomeClassname}
  style={{
    color: '#868e96', // Default color
    transition: 'color 0.3s',
    cursor: 'pointer'
  }}
  onMouseOver={(e) => {
    e.currentTarget.style.color = skills.hexcode;
    e.currentTarget.nextSibling.style.color = skills.hexcode; // Set color for adjacent <p> element
  }}
  onMouseOut={(e) => {
    e.currentTarget.style.color = '#868e96';
    e.currentTarget.nextSibling.style.color = '#868e96'; // Reset color for adjacent <p> element
  }}
></i>
<p>{skills.skillName}</p>

                
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
